import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

// AuraMax verified badge with a small premium "VERIFIED BY AURAMAX" popover.
export function VerifiedBadge({ size = 15, className }) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <span ref={ref} className={cn("relative inline-flex", className)}>
      <span
        role="button"
        tabIndex={0}
        data-testid="verified-badge"
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
        onMouseEnter={() => setOpen(true)}
        className="inline-flex shrink-0 cursor-pointer items-center"
        aria-label="Verified by AuraMax"
      >
        <BadgeCheck className="text-aura-cyan" style={{ width: size, height: size }} strokeWidth={2.4} fill="currentColor" stroke="#060708" />
      </span>
      {open && (
        <div
          data-testid="verified-popover"
          onMouseLeave={() => setOpen(false)}
          className="absolute left-1/2 top-6 z-50 w-60 -translate-x-1/2 rounded-2xl border border-am-border-strong bg-am-surface2 p-3.5 shadow-2xl"
          style={{ boxShadow: "0 12px 48px rgba(0,0,0,0.6)" }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center gap-2">
            <BadgeCheck className="h-5 w-5 text-aura-cyan" fill="currentColor" stroke="#060708" strokeWidth={2.4} />
            <span className="text-sm font-bold text-white">Verified by AuraMax</span>
          </div>
          <p className="mt-1.5 text-xs leading-relaxed text-am-text2">This is a real person and their verified AuraMax account.</p>
          <button
            onClick={() => { setOpen(false); navigate("/u/auramaxceo"); }}
            className="mt-2.5 text-xs font-semibold aura-text hover:underline"
          >
            DM @auramaxceo for verification.
          </button>
        </div>
      )}
    </span>
  );
}
